import init from './init';
import themeEditor from './themeEditor';
import { initSlider } from './slider';

export default () => {
  init();
  themeEditor();
  initSlider();

  const resizeEvent = new Event('resize');

  // Dispatch the event on the window object
  window.dispatchEvent(resizeEvent);
};
